<template>
  <gj-modal
    :visible.sync="modalVisible"
    :destroyOnClose="true"
    size="auto"
    width="450px"
    :loading="loading"
    :confirm-loading="confirmLoading"
    @cancel="cancel"
    @confirm="confirm"
  >
    <template #header>
      <span>调价</span>
    </template>
    <template #content>
      <el-row style="margin-bottom: 14px">
        <el-col :span="11"
          >当前原价
          <span style="padding-left: 5px"
            >{{ item.currencySymbol }}{{ item.yourPrice }}</span
          ></el-col
        >
        <el-col :span="12"
          >当前优惠价<span style="padding-left: 7px"
            >{{ item.currencySymbol }}{{ item.salePrice }}</span
          ></el-col
        >
      </el-row>
      <div>
        <el-form :model="form" ref="form" class="gj-form" label-position="right" label-width="60px">
          <el-row>
            <el-col :span="12">
              <el-form-item
                prop="newYourPrice"
                label="新原价"
                :rules="[$gjReRule(RE.num(2), '请输入正确的数值,最多保留两位小数')]"
              >
                <gj-input :width="inputWidth" v-model="form.newYourPrice">
                  <template slot="prepend">$</template>
                </gj-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="新优惠价"
                prop="newSalePrice"
                :rules="[$gjReRule(RE.num(2), '请输入正确的数值,最多保留两位小数')]"
              >
                <gj-input :width="inputWidth" v-model="form.newSalePrice">
                  <template slot="prepend">$</template>
                </gj-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
            label="优惠日期"
            :rules="{
              validator: validateSaleRangeDate,
            }"
            prop="saleRangeDate"
          >
            <gj-date-picker
              v-model="form.saleRangeDate"
              :width="'300px'"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></gj-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <!--        </el-tab-pane>-->
      <!--      </el-tabs>-->
    </template>
  </gj-modal>
</template>

<script>
import { formRuleMixin, modalMixIn } from '../../../../../minxins';
import { editGoodPrice } from '../../../../../api/sale';
import AppListingHeader from './listing-header';
import { convertToDate } from '@/utils/date.util';

export default {
  name: 'change-price',
  components: { AppListingHeader },
  mixins: [modalMixIn, formRuleMixin],
  props: {
    id: {
      required: true,
    },
    item: {
      default: () => {
        return {};
      },
    },
  },
  created() {},
  data() {
    return {
      validateSaleRangeDate: (rule, value, callback) => {
        if (
          this.form.salePrice &&
          (!Array.isArray(this.form.saleRangeDate) || this.form.saleRangeDate.length < 1)
        ) {
          callback(new Error('已填优惠价， 请输入优惠日期'));
        } else {
          callback();
        }
      },
      form: {
        newYourPrice: '',
        newSalePrice: '',
        saleRangeDate: [this.item.saleStartDate, this.item.saleEndDate],
      },
      inputWidth: '110px',
      loading: false,
    };
  },
  methods: {
    confirm() {
      this.confirmLoading = true;
      let params = { ...this.form, listingId: this.item.id };
      if (Array.isArray(this.form.saleRangeDate) && this.form.saleRangeDate.length > 1) {
        params.saleStartDate = convertToDate(this.form.saleRangeDate[0]);
        params.saleEndDate = convertToDate(this.form.saleRangeDate[1]);
      }
      editGoodPrice(params)
        .then(() => {
          this.$gjMessage.success('操作成功');
          this.$emit('after');
        })
        .complete(() => (this.confirmLoading = false));
    },
  },
};
</script>

<style lang="scss" scoped>
.setting-icon {
  font-size: 16px;
  margin-left: 4px;
  display: none;
  cursor: pointer;
}
.setting-wrapper:hover .setting-icon {
  display: inline;
  line-height: 1;
}
.B2B-price {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.B2B-price-item {
  margin: 0;
}
.B2B-price-message {
  white-space: nowrap;
}
.B2B-icon {
  font-size: 20px;
}
/deep/ .el-dialog__body {
  padding-bottom: 0;
}
</style>
